<template>
  <div class='loginBox'>
    <p class="logoBox">
      <img alt="" class="logo" src="@/assets/img/logo.png">
    </p>
    <div class="inputBox">
      <van-field v-model="text" :border="false" :label="$t('邮箱')" :placeholder="$t('请输入邮箱')" />
      <van-field v-model="password" :border="false" :label="$t('密码')" :placeholder="$t('请输入登录密码')" type="password" />
      <van-field v-model="localeTxt" :border="false" :label="$t('语言')" :placeholder="$t('请选择语言')" readonly
        right-icon="arrow-down" @click="checkLocale" />
    </div>
    <div class="btn" @click="loginBtn">{{ $t('登录') }}</div>
    <div class="operate">
      <span class="forgotPass" @click="router('/download')">{{ $t('下载') }}</span>
      <span class="forgotPass" @click="router('/password')">{{ $t('忘记密码') }}</span>
    </div>
    <div class="protocol">
      <img v-show="!check" alt="" class="radioImg" src="@/assets/img/check2.png" @click="check = !check">
      <img v-show="check" alt="" class="radioImg" src="@/assets/img/check1.png" @click="check = !check">
      <div class="txt">
        {{ $t('已阅读并同意') }}
        <span class="tc1" @click="router('/agreement', { type: 1 })">{{ $t('服务协议') }}</span>
        {{ $t('和 ') }}
        <span class="tc1" @click="router('/agreement', { type: 2 })">{{ $t('隐私政策') }}</span>
      </div>
    </div>
    
    <!-- Google验证器模态框 -->
    <van-popup v-model="showGoogleAuthModal" :close-on-click-overlay="false" position="center" round>
      <div class="google-auth-modal">
        <div class="modal-header">
          <h3>{{ $t('Google验证') }}</h3>
        </div>
        <div class="modal-body">
          <p>{{ $t('请输入Google验证器生成的6位动态码') }}</p>
          <van-field 
            v-model="googleAuthCode" 
            :placeholder="$t('6位动态码')" 
            type="number" 
            maxlength="6"
            class="auth-code-input"
          />
        </div>
        <div class="modal-footer">
          <van-button type="default" @click="cancelGoogleAuth" class="cancel-btn">{{ $t('取消') }}</van-button>
          <van-button type="primary" @click="verifyGoogleAuth" :disabled="googleAuthCode.length !== 6" class="confirm-btn">{{ $t('验证') }}</van-button>
        </div>
      </div>
    </van-popup>
    
    <van-popup v-model="fieldShow" :close-on-click-overlay="false" position="bottom">
      <van-picker :columns="columns" :title="$t('选择语言')" show-toolbar @cancel="onCancel" @confirm="onConfirm" />
    </van-popup>
  </div>
</template>

<script>
  export default {
    components: {},
    data() {
      return {
        text: "",//
        password: "",//
        check: false,
        locale: "",
        localeTxt: "",
        fieldShow: false,
        columns: [
          { id: 0, text: this.$t("中文"), locale: "zh" },
          { id: 1, text: this.$t("英文"), locale: "en" },
        ],
        // Google验证器相关
        showGoogleAuthModal: false,
        googleAuthCode: '',
        loginResponse: null, // 保存登录响应数据
      }
    },
    computed: {},
    watch: {
      googleAuthCode(newVal) {
        // 限制只能输入数字
        this.googleAuthCode = newVal.replace(/\D/g, '');
      }
    },
    methods: {
      // 登录方法
      loginBtn() {
          if (!this.text) return this.$toast(this.$t("请输入邮箱"))
          if (!this.password) return this.$toast(this.$t("请输入登录密码"))
          if (!this.check) return this.$toast(this.$t("请同意服务协议与隐私政策"))
          
          this.$post({
              url: `/login`,
              loading: true,
              noToken: true,
              data: {
                  account: this.text,
                  password: this.password,
              },
              success: (res) => {
                  console.log('Login response:', res);
                  
                  // 检查是否需要Google验证
                  if (res.data.is_google_auth_enabled) {
                      console.log('Login Success Response:', res); // 调试信息
            
                      // 检查是否需要Google验证
                      if (res.data.is_google_auth_enabled) {
                          console.log('Google Auth Required'); // 调试信息
                          this.loginResponse = res;
                          this.showGoogleAuthModal = true;
                      } else {
                          console.log('Direct Login Success'); // 调试信息
                          this.handleLoginSuccess(res);
                      }
                  } else {
                      // 不需要Google验证，直接登录成功
                      this.handleLoginSuccess(res);
                  }
              },
              error: (err) => {
                  console.error('Login error:', err);
                  this.$toast(err.message || this.$t("登录失败"));
              }
          })
      },

      
      // 验证Google验证码
      verifyGoogleAuth() {
          if (this.googleAuthCode.length !== 6) {
              return this.$toast(this.$t("请输入6位验证码"));
          }
          
          this.$post({
              url: `/member/verifyGoogleAuth`,
              loading: true,
              data: {
                  account: this.text,
                  password: this.password,
                  code: this.googleAuthCode
              },
              success: (res) => {
                  this.showGoogleAuthModal = false;
                  this.googleAuthCode = '';
                  this.handleLoginSuccess(res);
                  // this.local.set("token", res.data.token)
                  // this.toast({
                  //   message: this.$t(this.$t('登录成功')),
                  //   onClose: () => {
                  //     if (this.$router) {
                  //         this.$router.replace("/");
                  //     } else {
                  //         // 备用方案：使用 window.location
                  //         window.location.href = "/";
                  //     }
                  //   },
                  // })
              },
              error: (err) => {
                  this.$toast(err.message || this.$t("验证码错误"));
              }
          })
      },
      
      // 取消Google验证
      cancelGoogleAuth() {
        this.showGoogleAuthModal = false;
        this.googleAuthCode = '';
        this.loginResponse = null;
      },
      
      // 处理登录成功
      handleLoginSuccess(res) {
          // 保存token到本地存储
          this.local.set("token", res.data.token);
          
          // 保存用户信息
          this.local.set("user", JSON.stringify(res.data.user));
          
          // 设置全局token
          this.$http.setToken(res.data.token);
          
          // 显示成功消息
          this.toast({
              message: this.$t(this.$t('登录成功')),
              onClose: () => {
                  if (this.$router) {
                      this.$router.replace("/");
                  } else {
                      // 备用方案：使用 window.location
                      window.location.href = "/";
                  }
              },
          });
      },
      
      checkLocale() {
        this.fieldShow = true
      },
      onConfirm(e) {
        this.localeTxt = e.text
        this.locale = e.locale
        this.fieldShow = false
        this.local.set("lang", e.locale)
        this.$router.go(0)
        // window.location.reload()
      },
      onCancel(e) {
        this.fieldShow = false
      },
    },
    created() {
      this.locale = this.local.get("lang") ? this.local.get("lang") : "zh"
      this.localeTxt = this.locale ? this.locale == "zh" ? this.$t("中文（繁体）") : this.$t("英文") : ""
      this.local.set("lang", this.locale)
    },
    mounted() {
    },
    beforeCreate() {
    }, //生命周期 - 创建之前
    beforeMount() {
    }, //生命周期 - 挂载之前
    beforeUpdate() {
    }, //生命周期 - 更新之前
    updated() {
    }, //生命周期 - 更新之后
    beforeDestroy() {
    }, //生命周期 - 销毁之前
    destroyed() {
    }, //生命周期 - 销毁完成
    activated() {
    }, //如果页面有keep-alive缓存功能，这个函数会触发
  }
</script>

<style lang='less' scoped>
  .loginBox {
    width: 100%;
    min-height: 100vh;
    padding: 30px;
    background-image: url("../../../assets/img/login.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    .logoBox {
      text-align: center;
      margin-bottom: 20px;
      .logo {
        width: 122px;
        height: 122px;
      }
    }
    .inputBox {
      display: flex;
      flex-direction: column;
      gap: 20px 0;
      ::v-deep .van-field {
        background-color: #000000;
        border-radius: 7px;
        .van-field__label {
          color: #ffffff;
        }
        .van-field__value {
          .van-field__body {
            .van-field__control {
              color: #ffffff;
            }
          }
        }
      }
    }
    .btn {
      padding: 10px 0;
      background-color: #cbac7b;
      border-radius: 8px;
      margin-top: 60px;
      text-align: center;
      font-size: 15px;
      font-weight: bold;
    }
    .operate {
      display: flex;
      justify-content: space-between;
      margin-top: 15px;
      .forgotPass {
        font-size: 12px;
        color: #999999;
      }
    }
    .protocol {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0 10px;
      margin-top: 100px;
      .radioImg {
        width: 15px;
        height: 15px;
      }
      .txt {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        color: #999999;
        .tc1 {
          margin: 0 5px;
          color: #adadad;
        }
      }
    }
  }
  
  // Google验证器模态框样式
  .google-auth-modal {
    width: 300px;
    padding: 20px;
    background-color: #fff;
    border-radius: 8px;
    
    .modal-header {
      text-align: center;
      margin-bottom: 15px;
      
      h3 {
        margin: 0;
        color: #333;
      }
    }
    
    .modal-body {
      text-align: center;
      margin-bottom: 20px;
      
      p {
        margin: 0 0 15px 0;
        color: #666;
        font-size: 14px;
      }
      
      .auth-code-input {
        ::v-deep .van-field__control {
          text-align: center;
          font-size: 18px;
          letter-spacing: 2px;
        }
      }
    }
    
    .modal-footer {
      display: flex;
      justify-content: space-between;
      
      .cancel-btn {
        flex: 1;
        margin-right: 10px;
      }
      
      .confirm-btn {
        flex: 1;
        margin-left: 10px;
      }
    }
  }
</style>
